import React, { Fragment, useEffect, useMemo } from 'react';
import styles from './CampusLife.module.scss';
import Text from '../../../atoms/text/Text';
import { ToggleList } from '../../../molecule/ToggleList/ToggleList';
import ScrollReveal from 'scrollreveal';
import LazyVideo from '../../../atoms/lazyVideo/LazyVideo';
import Backdrop from '../../../atoms/backdrop/Backdrop';
import defaultImage from '../../../../assets/images/defaultNews.png';
import useIsRtl from '../../../../app/helpers/isRtl';

const SECTION_ID = 4;
const campusLifeVideo = '/videos/homepage/360video.mp4';

const CampusLife = ({ currentSection }) => {
  const isRtl = useIsRtl();
  useEffect(() => {
    ScrollReveal().reveal('#text', {
      delay: 100,
      duration: 500,
      easing: 'ease-in-out',
      opacity: 0,
      scale: 0.9,
      distance: '20px',
      reset: true,
    });
    ScrollReveal().reveal('#toggle >*', {
      delay: 500,
      duration: 500,
      easing: 'ease-in-out',
      opacity: 0,
      scale: 0.9,
      distance: '20px',
      reset: true,
    });
  }, []);
  const toggleData = [
    {
      id: 5,
      title: 'navigationMenu.academic_journey',
      route: '/students-affairs/student-life',
      direction: 'right',
    },
    {
      id: 2,
      title: 'home.facilities',
      route: '/students-affairs/facilities',
      direction: 'right',
    },
    {
      id: 1,
      title: 'affairs.alumni',
      route: '/students-affairs/alumni',
      direction: 'left',
    },

    // {
    //   id: 3,
    //   title: 'home.council',
    //   route: '/council/overview',
    //   isLink: '/route',

    //   direction: 'right',
    // },
    // {
    //   id: 4,
    //   title: 'home.research',
    //   route: '/research',
    //   direction: 'right',
    // },
    {
      id: 4,
      title: 'studentServices.Student_Services',
      route: '/students-affairs/student-services',
      direction: 'right',
    },
    // {
    //   id: 5,
    //   title: 'home.lesson_to_learn',
    //   route: '/route',
    //   direction: 'right',
    // },
  ];
  const loadVideo =
    currentSection >= SECTION_ID - 1 && currentSection <= SECTION_ID + 1;

  const lazyVideoElement = useMemo(() => {
    return (
      <LazyVideo
        src={campusLifeVideo}
        isPaused={currentSection !== SECTION_ID}
      />
    );
  }, [currentSection]);

  return (
    <div
      className={styles['campus-life']}
      style={{ backgroundImage: defaultImage }}
    >
      {loadVideo ? lazyVideoElement : null}

      <Backdrop />
      <Text
        id="text"
        title="navigationMenu.student_life"
        variant="text-bold-italic-80"
        style={{ textTransform: 'uppercase' }}
        isLineBreak
        className="slide-in"
      />
      <div className={styles['program']}>
        <div
          id="toggle"
          className={styles['toggle-container']}
          style={{ direction: isRtl ? 'rtl' : '' }}
        >
          <ToggleList data={toggleData} isNavigable />
        </div>
      </div>
    </div>
  );
};

export default CampusLife;
